var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDelete = function SvgDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "delete copy"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle Copy 9",
    fill: "#fff",
    stroke: "current",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 45,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 107"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m31.284 17.47-.442-1.324a1.232 1.232 0 0 0-1.17-.843h-3.71V14.1a1.1 1.1 0 0 0-1.095-1.1h-3.4a1.1 1.1 0 0 0-1.094 1.1v1.2h-3.711a1.232 1.232 0 0 0-1.17.843l-.441 1.327a.991.991 0 0 0 .94 1.3h.462l1.015 12.568A1.817 1.817 0 0 0 19.269 33h8a1.817 1.817 0 0 0 1.8-1.663l1.02-12.562h.256a.991.991 0 0 0 .94-1.3Z",
    fill: "#376996"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M21.545 14.172h3.245v1.132h-3.245ZM27.905 31.243a.639.639 0 0 1-.633.585h-8a.639.639 0 0 1-.633-.585l-1.011-12.468h11.285ZM16.242 17.604l.362-1.085a.061.061 0 0 1 .058-.042h13.011a.061.061 0 0 1 .058.042l.362 1.086Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M26.035 31.202h.031a.586.586 0 0 0 .585-.555l.55-10.562a.586.586 0 0 0-1.17-.061l-.551 10.562a.586.586 0 0 0 .555.616ZM19.71 30.648a.586.586 0 0 0 .585.554h.033a.586.586 0 0 0 .553-.617l-.577-10.563a.586.586 0 0 0-1.171.064ZM23.174 31.202a.586.586 0 0 0 .586-.586V20.054a.586.586 0 0 0-1.172 0v10.562a.586.586 0 0 0 .586.586Z",
    fill: "#376996"
  }))));
};
export default SvgDelete;